import React from 'react';
import cn from 'classnames';

var styles = {"checkmark":"select__checkmark_1xzud","selected":"select__selected_1xzud"};
require('./index.css');

var Checkmark = function (_a) {
    var _b;
    var selected = _a.selected;
    return (React.createElement("span", { className: cn(styles.checkmark, (_b = {},
            _b[styles.selected] = selected,
            _b)) }));
};

export { Checkmark };
